import BreadCrumbs from 'components/breadcrumbs'
import LoadingV2 from 'components/LoadingV2'
import PMBModalImagePreview from 'components/PMBModalImagePreview'
import { P } from 'components'
import PMBPagination from 'components/PMBPagination'
import PMBProgressBarExportFile from 'components/PMBProgressBarExportFile'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import PMBSelect from 'components/PMBSelect'
import PMBTooltip from 'components/PMBTooltip'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Check, ChevronDown, ChevronUp, Eye, Filter, X } from 'react-feather'
import { PMBDateRangePicker } from 'components/PMBNewDatePicker'
import {
  Badge,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
  Collapse,
  FormGroup,
  Label,
  Col,
  Row,
} from 'reactstrap'
import { useDebounce } from 'helpers'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import moment from 'moment-timezone'
import { useNavigate } from 'react-router-dom'
import {
  FILTER_CATCHES_LIST_OPTIONS,
  PROVINCES_OPTIONS,
  WPP_OPTIONS,
} from 'constants'
import Flatpickr from 'react-flatpickr'
import { formatDateOnlyPMB } from 'utils/formatDate'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { BUSINESS_TRIPS, MANAGE } from 'utils/subjectActions'
import IconApprove from '../../../../assets/icons/icon-approve.svg'
import IconNotApprove from '../../../../assets/icons/icon-unapprove.svg'
import VesselNotFound from '../../../../assets/icons/vessel-not-found.png'
import { useFetchCatchesListQuery, useLazyFetchCatchesListQuery } from './catchesListApiSlice'
import {
  setFilters,
  setIsOpenModalApprove,
  setFetchOption,
} from './catchesListSlice'
import {
  handleDownloadCSV,
  handleDownloadExcel,
  handleDownloadJSON,
} from './DownloadReport'
import ModalApprove from './ModalApprove'
import LihatDetail from 'components/Icons/LihatDetail'
import CustomButton from 'components/Buttons/CustomButton'
import { Can } from 'context/Acl'

const CatchesTable = () => {
  const { isOpenModalApprove, filters } = useSelector((s) => s.catchesList)
  const [fetchCatchesList] = useLazyFetchCatchesListQuery()

  const manageActionApproveBusinessTrips = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_TRIPS,
  })

  const endDateDefault = moment().format('YYYY-MM-DD')
  const startDateDefault = moment().subtract(3, 'months').format('YYYY-MM-DD')

  const savedFilters =
    JSON?.parse(localStorage?.getItem('catchesFilters')) || {}
  const [currentPage, setCurrentPage] = useState(savedFilters?.page ?? 0)
  const [rowsPerPage, setRowsPerPage] = useState(savedFilters?.size ?? 10)
  const [searchInput, setSearchInput] = useState(
    savedFilters?.searchInput ?? '',
  )
  const [search, setSearch] = useState(savedFilters?.search ?? '')

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [isFilterOpen, setIsFilterOpen] = useState(
    savedFilters?.isFilterOpen ?? false,
  )
  const [modalOpenImage, setModalOpenImage] = useState(false)
  const [imageItems, setImagesItems] = useState([])
  const [isNoDataFilterAvailable, setIsNoDataFilterAvailable] = useState(false)
  // STATE DOWNLOAD REPORT
  const [isDialogShow, setIsDialogShow] = useState(false)
  const [firstRows, setFirstRows] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const [detailRow, setDetailRow] = useState(null)

  // SORT BY FILTER
  const [sortColumn, setSortColumn] = useState(
    savedFilters?.sortColumn ?? 'startfishing',
  )
  const [sortDirection, setSortDirection] = useState(
    savedFilters?.sortDirection ?? 'DESC',
  )

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const timeZone = 'Asia/Jakarta'

  const { data, isLoading, refetch, isFetching } = useFetchCatchesListQuery({
    page: currentPage ?? 0,
    size: rowsPerPage ?? 10,
    s: search ?? '',
    from: filters?.selectedDate[0]
      ? moment(filters?.selectedDate[0])
          .utcOffset('+07:00')
          .startOf('day')
          .format()
      : undefined,
    to: filters?.selectedDate[1]
      ? moment(filters?.selectedDate[1])
          .utcOffset('+07:00')
          .endOf('day')
          .format()
      : undefined,
    filterwpp: filters?.selectedWPP?.value?.match(/\d+/)?.[0] ?? '',
    filterapprove: filters?.status?.value ?? '',
    filterdistrict: filters?.province?.value ?? '',
    sortby: sortColumn ?? 'startfishing',
    sortdir: sortDirection ?? 'DESC',
  })

  const getQueryParams = () => ({
    s: search ?? '',
    from: filters?.selectedDate[0]
      ? moment(filters?.selectedDate[0])
          .utcOffset('+07:00')
          .startOf('day')
          .format()
      : undefined,
    to: filters?.selectedDate[1]
      ? moment(filters?.selectedDate[1])
          .utcOffset('+07:00')
          .endOf('day')
          .format()
      : undefined,
    filterwpp: filters?.selectedWPP?.value?.match(/\d+/)?.[0] ?? '',
    filterapprove: filters?.status?.value ?? '',
    filterdistrict: filters?.province?.value ?? '',
    sortby: sortColumn ?? 'startfishing',
    sortdir: sortDirection ?? 'DESC',
  })

  const menuItems = [
    // {
    //   label: 'Download as CSV',
    //   action: () => {
    //     handleDownloadCSV(data, setIsDialogShow, setFirstRows, setTotalRows, fetchCatchesList, getQueryParams())
    //   },
    // },
    {
      label: 'Download as Excel',
      action: () => {
        handleDownloadExcel(data, setIsDialogShow, setFirstRows, setTotalRows, fetchCatchesList, getQueryParams())
      },
    },
    {
      label: 'Download as JSON',
      action: () => {
        handleDownloadJSON(data, setIsDialogShow, setFirstRows, setTotalRows, fetchCatchesList, getQueryParams())
      },
    },
  ]

  // HANDLE LOADING FILTER
  useEffect(() => {
    if (!isFetching && data?.totalItems === 0) {
      setIsNoDataFilterAvailable(true)
    } else {
      setIsNoDataFilterAvailable(false)
    }
  }, [isFetching, data?.totalItems])

  // Restore saved filters from localStorage on mount
  useEffect(() => {
    if (savedFilters && Object.keys(savedFilters).length) {
      // restore filters
      const restoredFilter = {
        status: savedFilters.status ?? filters?.status,
        province: savedFilters.province ?? filters?.province,
        selectedDate:
          savedFilters?.selectedDate?.length === 2
            ? savedFilters.selectedDate
            : filters?.selectedDate,
        selectedWPP: savedFilters.selectedWPP ?? filters?.selectedWPP,
      }

      dispatch(setFilters(restoredFilter))
      // restore pagination, sorting and search
      setCurrentPage(savedFilters?.page ?? 0)
      setRowsPerPage(savedFilters?.size ?? 10)
      setSortColumn(savedFilters?.sortColumn ?? 'startfishing')
      setSortDirection(savedFilters?.sortDirection ?? 'DESC')
      setSearch(savedFilters?.search ?? '')
      setSearchInput(savedFilters?.searchInput ?? '')
      setIsFilterOpen(savedFilters?.isFilterOpen ?? false)
      // also set the redux tag page/size if needed
      dispatch(
        setFetchOption({
          page: savedFilters?.page ?? 0,
          size: savedFilters?.size ?? 10,
        }),
      )
    }
  }, [])

  const debouncedSearch = useDebounce((value) => {
    setCurrentPage(0)
    setRowsPerPage(10)
    setSearch(value)
    refetch()
  }, 600)

  const handleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const WPPOptions = [{ value: '', label: 'Semua' }, ...WPP_OPTIONS]

  const getActiveFiltersCount = () => {
    let count = 0
    try {
      if (search && String(search).trim() !== '') count++
      if (filters?.status?.value) count++
      if (filters?.province?.value) count++
      if (filters?.selectedWPP?.value) count++

      // selectedDate default check
      if (filters?.selectedDate && Array.isArray(filters.selectedDate)) {
        const from = filters.selectedDate[0]
        const to = filters.selectedDate[1]
        if (
          from &&
          to &&
          (from !== startDateDefault || to !== endDateDefault)
        ) {
          count++
        }
      }
    } catch (e) {
      // ignore
    }

    return count
  }

  const handleClearFilters = () => {
    setSearchInput('')
    setSearch('')
    setCurrentPage(0)
    setRowsPerPage(10)
    dispatch(
      setFilters({
        status: FILTER_CATCHES_LIST_OPTIONS[0],
        province: PROVINCES_OPTIONS[0],
        selectedDate: [startDateDefault, endDateDefault],
        selectedWPP: { value: '', label: 'Semua' },
      }),
    )
    refetch()
    // Clear persisted filters for catches
    localStorage.removeItem('catchesFilters')
  }

  // Persist catches filters to localStorage on change
  useEffect(() => {
    const filtersToSave = {
      status: filters.status,
      province: filters.province,
      selectedDate:
        filters?.selectedDate?.length === 2
          ? filters.selectedDate
          : filters.selectedDate,
      selectedWPP: filters.selectedWPP,
      page: currentPage,
      size: rowsPerPage,
      search: search,
      searchInput: searchInput,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      isFilterOpen: isFilterOpen,
    }
    localStorage.setItem('catchesFilters', JSON.stringify(filtersToSave))
  }, [
    filters.status,
    filters.province,
    filters.selectedDate,
    filters.selectedWPP,
    currentPage,
    rowsPerPage,
    search,
    searchInput,
    sortColumn,
    sortDirection,
    isFilterOpen,
  ])

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState)
  }

  const handleSort = (column, direction) => {
    setSortColumn(column.selector)
    setSortDirection(direction === 'asc' ? 'ASC' : 'DESC')
  }

  const onHandleOpenImageModal = (imageUrls) => {
    setImagesItems([imageUrls])
    setModalOpenImage(true)
  }

  const columns = [
    {
      name: <span>Tanggal Perjalanan</span>,
      selector: 'startfishing',
      sortable: true,
      cell: (row) => {
        const startDate = formatDateOnlyPMB(row?.data?.startFishing)
        const endDate = formatDateOnlyPMB(row?.data?.endFishing)
        return (
          <span>
            {startDate ?? ''} - {endDate ?? ''}
          </span>
        )
      },
      minWidth: '150px',
    },
    {
      name: <span>Kapal</span>,
      selector: 'shipname',
      sortable: true,
      cell: (row) => {
        return (
          <div className="flex-centered gap-2">
            <img
              src={row?.data?.vessel?.linkImage ?? VesselNotFound}
              alt={row?.data?.vessel?.vesselName ?? 'vessel'}
              width={32}
              height={32}
              className="rounded-circle"
              onClick={() =>
                onHandleOpenImageModal(
                  row?.data?.vessel?.linkImage ?? VesselNotFound,
                )
              }
              style={{ cursor: 'pointer' }}
            />
            <span className="fw-bold text-primary m-0">
              {row?.data?.vessel?.shipName}
            </span>
          </div>
        )
      },
      minWidth: '200px',
    },
    {
      name: <span>Nama Nelayan</span>,
      selector: 'name',
      sortable: true,
      cell: (row) => {
        return <span>{row?.profile?.name ?? ''}</span>
      },
      minWidth: '200px',
    },
    {
      name: <span>Hasil Tangkapan</span>,
      minWidth: '150px',
      selector: 'fishname',
      sortable: true,
      cell: (row) => {
        const fishes = row?.data?.fishes ?? []

        const firstFish = fishes[0]
        const firstFishName = firstFish?.selectedFish?.nameItem
        const firstFishCode = firstFish?.selectedFish?.attribute?.code ?? ''
        const firstFishAmount = firstFish?.amount ?? 0

        const additionalFishesCount =
          fishes?.length > 1 ? fishes?.length - 1 : 0

        const unit = fishes?.[0]?.selectedFish?.unit ?? 'kg'

        return (
          <div>
            <div className="my-1">
              <span className="fw-semibold">
                {firstFishName} <em>({firstFishCode})</em>
              </span>
            </div>
            <div className="my-1">
              <span className="text-primary">
                {newFormatThousandSeparator(firstFishAmount)} {unit}
              </span>
            </div>

            {additionalFishesCount > 0 && (
              <Badge className="badge-gray my-1">
                + {additionalFishesCount} tangkapan lainnya
              </Badge>
            )}
          </div>
        )
      },
    },
    {
      name: <span>Total Penangkapan (kg)</span>,
      right: true,
      cell: (row) => {
        const unit = row?.data?.fishes?.[0]?.selectedFish?.unit ?? 'kg'
        const totalAmount = row.data.fishes.reduce(
          (sum, fish) => Number(sum) + Number(fish.amount),
          0,
        )

        return (
          <span>
            {newFormatThousandSeparator(totalAmount)} {unit}
          </span>
        )
      },
      minWidth: '150px',
    },
    {
      name: <span>WPP</span>,
      selector: 'wpp',
      sortable: true,
      width: '120px',
      cell: (row) => {
        const catchAreas = [
          ...new Set(row?.data?.fishes?.map((fish) => fish?.catchArea)),
        ].join(', ')

        return <span>{catchAreas}</span>
      },
      minWidth: '150px',
    },
    {
      name: <span>Status</span>,
      minWidth: '150px',
      cell: (row) => {
        // HANDLE ABILITY AND APPROVE
        if (row?.data?.approved === true) {
          return (
            <>
              <img
                src={IconApprove}
                id={`approve-${row?.id}`}
                alt={`approve-${row?.id}`}
                loading="lazy"
              />
              <PMBTooltip target={`approve-${row?.id}`} text="Terverfikasi" />
            </>
          )
        }

        return (
          <>
            <img
              src={IconNotApprove}
              id={`not-approve-${row?.id}`}
              alt={`not-approve-${row?.id}`}
              loading="lazy"
            />
            <PMBTooltip
              target={`not-approve-${row?.id}`}
              text="Belum Terverifikasi"
            />
          </>
        )
      },
    },
    {
      name: '',
      minWidth: '80px',
      cell: (row) => {
        return (
          <div
            className="d-flex gap-4 align-items-center"
            data-testid={`catches-table-row-${row?.id}`}
          >
            <LihatDetail
              onClick={() => {
                navigate(`/catches/${row?.id}`)
              }}
              id={row?.id}
              data-testid={`catches-row-detail-${row?.id}`}
            />
            {manageActionApproveBusinessTrips && !row?.data?.approved && (
              <>
                <div
                  id={`icon-verifikasi-${row?.id}`}
                  data-testid={`catches-row-approve-${row?.id}`}
                >
                  <Check
                    size={18}
                    onClick={() => {
                      dispatch(setIsOpenModalApprove())
                      setDetailRow(row)
                    }}
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                </div>
                <PMBTooltip
                  target={`icon-verifikasi-${row?.id}`}
                  text="Verifikasi"
                />
              </>
            )}
          </div>
        )
      },
    },
  ]

  const customStyles = {
    headCells: {
      style: {
        color: '#667085',
        backgroundColor: '#F9FAFB',
      },
    },
    cells: {
      style: {
        marginTop: '1px',
        marginBottom: '1px',
      },
    },
    rows: {
      style: {
        marginTop: '1px',
        marginBottom: '1px',
        '&:hover': {
          backgroundColor: '#F9FAFB',
        },
      },
    },
  }

  if (isLoading) {
    return <LoadingV2 />
  }

  const handleRefetch = () => {
    refetch()
  }

  return (
    <div className="w-100 px-3">
      <div className="mt-3">
        <BreadCrumbs breadCrumbActive="Daftar Perjalanan" />
      </div>

      {/* MODAL APPROVE */}
      <ModalApprove
        open={isOpenModalApprove}
        toggle={() => dispatch(setIsOpenModalApprove())}
        row={detailRow}
        handleRefetch={handleRefetch}
      />

      {/* MODAL IMAGE PREVIEW */}
      <PMBModalImagePreview
        isOpen={modalOpenImage}
        toggle={() => setModalOpenImage(!modalOpenImage)}
        images={imageItems}
      />

      <Card className="mb-4 border-0 shadow-sm">
        <CardBody>
          <DataTable
            customStyles={customStyles}
            columns={columns}
            data={data?.items}
            progressPending={isLoading || isFetching}
            responsive
            persistTableHead
            defaultSortFieldId={1}
            defaultSortAsc={false}
            paginationTotalRows={data?.totalItems}
            progressComponent={
              <div style={{ margin: '100px 0px' }}>
                <Spinner color="primary" />
              </div>
            }
            sortIcon={<ChevronDown />}
            sortServer
            onSort={handleSort}
            className="border p-0 border-1 rounded-top"
            noDataComponent={
              <p className="my-3 fw-semibold">
                {isNoDataFilterAvailable
                  ? 'Tidak ada data yang sesuai dengan filter Anda.'
                  : 'Belum ada daftar perjalanan yang didaftarkan.'}
              </p>
            }
            pagination
            paginationServer
            paginationComponent={(props) => (
              <PMBPagination
                rowCount={data?.totalItems || 0}
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                setCurrentPage={setCurrentPage}
                setRowsPerPage={setRowsPerPage}
                props={props}
                testId="catches-pagination"
              />
            )}
            subHeader={true}
            subHeaderComponent={
              <div className="w-100">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <h5 className="fw-semibold">Daftar Perjalanan</h5>

                  <Can I={MANAGE} this={BUSINESS_TRIPS}>
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                      <DropdownToggle
                        color="primary"
                        caret
                        data-testid="catches-download-button"
                      >
                        Download
                      </DropdownToggle>
                      <DropdownMenu>
                        {menuItems.map((item, index) => (
                          <DropdownItem
                            key={index}
                            onClick={item.action}
                            data-testid={`catches-download-item-${index}`}
                          >
                            <span className="text-sm">{item.label}</span>
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </Can>
                </div>

                <div className="row my-4">
                  <div
                    className="col-12 d-flex justify-content-end mb-2"
                    style={{ position: 'relative', gap: 4 }}
                  >
                    {getActiveFiltersCount() > 0 && (
                      <div className="flex-shrink-0">
                        <CustomButton
                          onClick={handleClearFilters}
                          color="danger"
                          className="d-flex align-items-center justify-content-center"
                          testId="catches-filter-clear-button"
                          style={{
                            width: '40px',
                            height: '40px',
                            padding: 0,
                            minWidth: '40px',
                          }}
                        >
                          <X size={16} />
                        </CustomButton>
                      </div>
                    )}

                    <CustomButton
                      color="primary"
                      outline
                      className="position-relative"
                      onClick={() => setIsFilterOpen((p) => !p)}
                      testId="catches-filter-toggle-button"
                    >
                      <div className="d-flex align-items-center gap-2 justify-content-center">
                        <Filter size={15} />
                        <P>Filter</P>
                        {getActiveFiltersCount() > 0 && (
                          <Badge
                            color="danger"
                            pill
                            style={{
                              position: 'absolute',
                              top: '-5px',
                              right: '5px',
                              fontSize: '10px',
                            }}
                          >
                            {getActiveFiltersCount()}
                          </Badge>
                        )}
                        {isFilterOpen ? (
                          <ChevronUp size={14} />
                        ) : (
                          <ChevronDown size={14} />
                        )}
                      </div>
                    </CustomButton>
                  </div>

                  <Collapse isOpen={isFilterOpen}>
                    <div
                      className="border rounded p-3 bg-light mb-3 filter-collapse"
                      style={{
                        width: '100%',
                        transition: 'all 0.3s ease-in-out',
                        opacity: isFilterOpen ? 1 : 0,
                        transform: isFilterOpen
                          ? 'translateY(0)'
                          : 'translateY(-10px)',
                      }}
                    >
                      {/* Group the inputs */}
                      <Row className="g-2">
                        {/* SEARCH */}
                        <Col xs={12} md={4} lg={3}>
                          <PMBSearchInputGroup
                            label={'Cari'}
                            value={searchInput}
                            placeholder="Cari nelayan, kapal, ikan, dll..."
                            onChange={(e) => handleSearchChange(e.target.value)}
                            maxWidth="100%"
                            testId="catches-search-input"
                          />
                        </Col>

                        {/* STATUS */}
                        <Col xs={12} md={4} lg={3}>
                          <PMBSelect
                            title="Status"
                            value={filters?.status}
                            options={FILTER_CATCHES_LIST_OPTIONS}
                            onChange={(item) => {
                              setCurrentPage(0)
                              setRowsPerPage(10)
                              dispatch(setFilters({ status: item }))
                            }}
                            style={{ width: '100%' }}
                            testId="catches-filter-status-select"
                          />
                        </Col>

                        {/* PROVINCE */}
                        <Col xs={12} md={4} lg={3}>
                          <PMBSelect
                            title="Provinsi"
                            value={filters?.province}
                            options={PROVINCES_OPTIONS}
                            onChange={(item) => {
                              setCurrentPage(0)
                              setRowsPerPage(10)
                              dispatch(setFilters({ province: item }))
                            }}
                            style={{ width: '100%' }}
                            testId="catches-filter-province-select"
                          />
                        </Col>
                        <Col xs={12} md="auto" lg="auto">
                          <FormGroup>
                            <PMBDateRangePicker
                              style={{ width: '100%', maxWidth: '100%' }}
                              data-testid="catches-filter-date-select"
                              value={filters?.selectedDate}
                              onChange={(dates) => {
                                if (dates?.length === 2) {
                                  setCurrentPage(0)
                                  setRowsPerPage(10)
                                  dispatch(
                                    setFilters({
                                      selectedDate: dates,
                                    }),
                                  )
                                  refetch()
                                }
                              }}
                              format="yyyy-mm-dd"
                              label="Tanggal Mulai & Akhir"
                              onClear={() => {
                                setCurrentPage(0)
                                setRowsPerPage(10)
                                dispatch(
                                  setFilters({
                                    selectedDate: [
                                      startDateDefault,
                                      endDateDefault,
                                    ],
                                  }),
                                )
                                refetch()
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col xs={12} md={4} lg={3}>
                          <FormGroup>
                            <Label className="text-sm">WPP-RI</Label>
                            <PMBSelect
                              label="WPP-RI"
                              style={{ width: '100%' }}
                              value={filters?.selectedWPP}
                              onChange={(e) => {
                                setCurrentPage(0)
                                setRowsPerPage(10)
                                dispatch(setFilters({ selectedWPP: e }))
                                refetch()
                              }}
                              options={WPPOptions}
                              placeholder="Pilih WPP"
                              testId="catches-filter-wpp-select"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>

                    {/* inline filters apply immediately on change; no action buttons needed */}
                  </Collapse>
                </div>
              </div>
            }
          />
        </CardBody>
      </Card>

      {/* Progress Bar Modal */}
      <PMBProgressBarExportFile
        isDialogShow={isDialogShow}
        firstRows={firstRows}
        totalRows={totalRows}
        onCancel={() => {
          setIsDialogShow(false)
        }}
      />
    </div>
  )
}

export default CatchesTable
